import { supabase } from '../lib/supabase';

class AuthHandler {
  private static instance: AuthHandler;

  private constructor() {}

  public static getInstance(): AuthHandler {
    if (!AuthHandler.instance) {
      AuthHandler.instance = new AuthHandler();
    }
    return AuthHandler.instance;
  }

  public async checkSession(): Promise<boolean> {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      return !error && !!session;
    } catch (error) {
      return false;
    }
  }

  public async getAuthenticatedClient() {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('Session error:', error);
        throw new Error(`Session error: ${error.message}`);
      }
      
      if (!session || !session.user) {
        throw new Error('No active session or user');
      }
      
      return supabase;
    } catch (error) {
      console.error('Auth client error:', error);
      throw error;
    }
  }

  public async signOut(): Promise<void> {
    try {
      // Always clear local storage first
      localStorage.removeItem('quickeloans-auth-token');
      
      // Attempt to sign out from Supabase, but don't throw if it fails
      await supabase.auth.signOut();
    } catch (error) {
      // Log the error but don't throw - we still want to clear local state
      console.warn('Supabase sign out failed, but local session cleared:', error);
    }
  }
}

export default AuthHandler.getInstance();